export default {
  maximumSelect: '最大15個まで選択可能です',
  maximumFiveSelect: '最大5個まで選択可能です',
  simpleRegistration: {
    skill: '経験スキル',
    job: '経験職種',
    japanese: '日本語レベル',
    japaneseLevel: '日本語レベル',
    jlpt: 'JLPT',
    preference: '希望条件',
    basicInformation: '基本情報',
    career: '経歴',
    jobPlaceholder: '職種名で検索（例：AIエンジニア、ブリッジSE）',
    skillPlaceholder: 'スキル名で検索（例：Java、AWS）',
    jlptDescription1: '*JLPT＝日本語能力試験',
    jlptDescription2: '*JLPTの認定資格をお持ちでない方は「なし」を選択してください。',
    currentAnnualSalary: '現在の年収',
    addPastCompanies: '過去の企業を追加',
    previousEmployers: '過去の在籍企業',
    previousEmployersDescription: 'リストは経歴の新しいものから自動的にソートされます。',
    companyNameMostRecent: '会社名(直近の在籍企業)',
    aiGeneratedButton: 'AIで生成',
    role: '役割',
    aiModal: {
      jobTitle: '職種名',
      jobTitlePlaceholder: '例：バックエンドエンジニア',
      role: '役割',
      rolePlaceholder: '例：テックリード',
      jobDescription: '業務の概要',
      jobDescriptionPlaceholder: '例：Java/Springを用いた自社期間システムのバックエンド開発およびAPI設計',
      jobDescriptionHint: 'AIが業務の詳細を生成する際の元情報になります',
      projectTaskDetails: 'プロジェクト / 業務の詳細',
      startGeneration: '生成を開始する',
      cancel: 'キャンセル',
      regenerate: '再度生成する',
      overwriteDetails: '業務の詳細に上書き',
      aiGeneratedDisclaimer: '上記はAIが自動生成した文章です。ご自身の経歴に合わせて必ず編集してから反映してください。',
      termsTitle: 'AIにおける業務の詳細生成に関する注意事項',
      termsItem1: '本機能は業務内容を補助する機能であり、内容の正確性や適切性を保証するものではありません。',
      termsItem2: '在籍した企業や関わった企業の機密情報、他人の個人情報を入力しないでください。',
      termsItem3: '本機能の利用には回数に限りがあります。',
      termsItem4: 'AIによる生成物は、必ずご自身で内容を確認・編集のうえご活用ください。',
      termsItem5: '生成後、「業務の詳細に上書き」ボタンを押すと、現在入力されている職務経歴の内容は上書きされます。',
      termsAgree: '上記の注意事項に同意します。',
      retry: '再試行',
      errorLimitReached: '生成回数の上限に達しました。',
      errorServiceUnavailable: 'AIサービスは現在利用できません。しばらくしてからもう一度お試しください。',
      errorTimeout: 'リクエストがタイムアウトしました。もう一度お試しください。',
      errorValidation: '入力内容が無効です。入力内容を確認してもう一度お試しください。',
      errorNetwork: 'ネットワークエラーです。接続を確認してもう一度お試しください。',
      errorGeneric: '予期しないエラーが発生しました。もう一度お試しください。'
    },
    workDetail: 'プロジェクト / 業務の詳細',
    workDetailPlaceholder:
      'プロジェクト：ECサイトのバックエンド開発\n' +
      '主な担当業務：Webアプリケーションのバックエンド開発を担当。\n' +
      'Spring BootとKotlinでREST APIを構築し、決済システムや商品管理機能などを実装。\n' +
      'AWSサービスを活用し、コスト削減とスケーラビリティ向上に貢献しました',
    workDetailForm: {
      validations: {
        workDetail: {
          required: 'プロジェクト / 業務の詳細を入力してください',
          maxLength: 'プロジェクト / 業務の詳細は2000文字以内で入力してください。',
          notIn: 'この項目はテンプレート文のまま利用できません'
        },
      }
    }  
  },
  steps: {
    step1: 'ステップ 1',
    step2: 'ステップ 2',
    step3: 'ステップ 3',
    step4: 'ステップ 4',
    step5: 'ステップ 5',
    step6: 'ステップ 6'
  },
  next: '次へ',
  back: '戻る',
  complete: '完了',
  steppers: {
    '01': '言語',
    '02': 'スキル/経験',
    '03': '希望条件',
    '✓': '登録完了'
  },
  finish: {
    completed: '登録完了',
    find: '求人サーチをして応募してみましょう！',
    search: '求人を探す',
    failed: '登録できませんでした。',
    try: '後でもう一度試すか、お問い合わせください。',
    back: 'ホーム画面に戻る',
    next: '次へ進む',
    profile: 'プロフィール詳細を入力',
    info: {
      line1: '必須情報の入力が完了しました',
      line2: '続けて、詳細情報を入力しましょう',
      line3: 'プロフィール情報を充実させることで、選考通過率・スカウト受信率が大幅に上昇します'
    }
  },
  experience: {
    skill: 'スキル',
    currentStatus: '現在の就業状況',
    work: '職務経験',
    education: '教育',
    personalInformation: '個人情報'
  },
  help: {
    title: 'ヘルプ',
    nativeLanguage: {
      title: '母国語',
      body: '二つ以上の母国語をお持ちの方も、いずれか一つを選択してください。'
    },
    speakingEnglish: {
      title: '英会話力/日本語会話力',
      body: `<strong class="foreground--text">母国語:</strong>
      様々な文法や複雑な言葉を含め、すべての面で完全に習得している

      <strong class="foreground--text">流暢:</strong>
      高度な会話においても苦労せずに会話ができ、相手と自然に意思疎通ができる
      
      <strong class="foreground--text">ビジネス:</strong>
      会議・プレゼンテーションなど、ビジネスの場でコミュニケーションをとり業務を行える
      
      <strong class="foreground--text">日常会話:</strong>
      雑談や日常会話であれば内容を理解し、相手とコミュニケーションをとることができる

      <strong class="foreground--text">挨拶以下:</strong>
      挨拶や簡単な自己紹介、「はい」「いいえ」は言える。またはそれ以下`
    },
    jlpt: {
      title: 'JLPT（日本語能力試験）',
      body: `<strong class="foreground--text">N1:</strong>
      幅広い場面で使われる日本語を理解することができる
      
      <strong class="foreground--text">N2:</strong>
      日常的な場面で使われる日本語の理解に加え、より幅広い場面で使われる日本語をある程度理解することができる

      <strong class="foreground--text">N3:</strong>
      日常的な場面で使われる日本語をある程度理解することができる

      <strong class="foreground--text">N4:</strong>
      基本的な日本語を理解することができる

      <strong class="foreground--text">N5:</strong>
      基本的な日本語をある程度理解することができる
      `
    },
    autoFillOut: {
      title: '自動入力',
      body: 'CVや職務経歴書ファイルをお持ちの場合、アップロードすることで入力をサポートします。'
    },
    gtalent: {
      title: 'G Talentとは?',
      body: '日本に住む外国人IT人材やバイリンガル日本人向けの人材紹介サービスです。あなたの日本の就職、転職をIT専門のリクルーターがサポートします。'
    }
  },
  tips: {
    default: {
      header: 'Welcome to GitTap',
      tip: `あなたの情報を入力してください。
      ご不明な点がございましたら、？マークをクリックしてください。
      
      ヘルプがここに表示されます。`
    },
    prefectures: {
      header: '都道府県を選択する',
      tip: '都道府県を選んでください'
    },
    industry: {
      header: '業界を選択する',
      tip: '業界を選んでください'
    },
    itSkill: {
      header: 'ITスキルを選択する',
      tip: 'あなたのITスキルを選んでください。'
    },
    jobRole: {
      header: '経験した職種を選択する',
      tip: 'あなたの過去に経験した職種を選んでください。'
    },
    school: {
      header: '学校情報を入力する',
      tip: '学歴を入力してください。'
    },
    company: {
      header: '会社を追加する',
      tip: '追加された会社は自動的にソートされます。'
    }
  },
  registerToGTalent:
    '<span style="font-size:13px;">同時に転職支援サービス<a href="https://www.gtalent.jp/" target="_blank" class="primary--text" style="text-decoration: none">G Talent</a>へも登録する。</span>',
  informationAccuracyConfirmation: '入力した内容（経歴・スキル等）に事実と異なる点がないことを確認しました。',
  informationAccuracyWarning: '※事実と異なる情報が確認された場合、利用規約に基づきアカウントの利用を停止することがあります。',
  workRemotelyFromOverseas: '日本国外からのリモートワークを希望する',
  gTalentHelp:
    '日本に住む外国人IT人材やバイリンガル日本人向けの人材紹介サービスです。あなたの日本の就職、転職をIT専門のリクルーターがサポートします。',
  gTalentDescription:
    '同時に転職支援サービス<strong>G Talent</strong>へも登録する。（サービスお申し込みにあたり、<a href="https://www.gtalent.jp/attention" target="_blank" class="primary--text" style="text-decoration: none">利用規約</a>及び<a href="https://www.gtalent.jp/privacy/member_reg" target="_blank" class="primary--text" style="text-decoration: none">個人情報の取り扱い（会員情報）</a>への同意が必要となります。）',
  yearsOfExperience: {
    fiveYears: '5年以上',
    threeToFiveYears: '3〜5年',
    oneToThreeYears: '1〜3年',
    lessThanOneYear: '1年未満'
  },
  welcome: {
    header: 'GitTapへようこそ',
    item1: '登録はまだ完了していません <br> プロフィールを充実させましょう',
    item2: '選考通過率・スカウト受信率が大幅に高まります',
    enterManually: '手動で入力'
  }
}
